import CopyIconComponent from 'components/ui/CopyIconComponent';
import React from 'react';
import { SearchInfo } from './types';
import { BoldText } from './styled';

interface PropTypes {
  searchInfo: SearchInfo;
}

export const WaterFormHeader = (props: PropTypes) => {
  return (
    <>
      <div style={{ display: 'flex', gap: 16, position: 'relative' }}>
        <div style={{ position: 'relative', marginRight: 16 }}>
          <BoldText>Property: </BoldText>
          <span style={{ marginLeft: '2px', marginRight: 8 }}>{props.searchInfo.address}</span>
          <CopyIconComponent
            style={{
              cursor: 'pointer',
              color: '#000',
              position: 'absolute',
              top: -8,
            }}
            textToCopy={`${props.searchInfo.address}`}
            afterCopyText="Copied Address!"
          />
        </div>
        <div>
          <BoldText>Block: </BoldText>
          <span style={{ marginLeft: '2px' }}>{props.searchInfo.block}</span>
        </div>
        <div style={{ position: 'relative', marginRight: props.searchInfo.qualifier ? 0 : 16 }}>
          <BoldText>Lot: </BoldText>
          <span style={{ marginLeft: '2px' }}>{props.searchInfo.lot}</span>
          {!props.searchInfo.qualifier && (
            <CopyIconComponent
              style={{
                cursor: 'pointer',
                color: '#000',
                position: 'absolute',
                top: -8,
                right: -30,
              }}
              textToCopy={`${props.searchInfo.block ? props.searchInfo.block + '-' : ''}${
                props.searchInfo.lot ? props.searchInfo.lot : ''
              }${props.searchInfo.qualifier ? '-' + props.searchInfo.qualifier : ''}`}
              afterCopyText="Copied SBL!"
            />
          )}
        </div>
        {props.searchInfo.qualifier && (
          <div style={{ position: 'relative', marginRight: 16 }}>
            <BoldText>Qualifier: </BoldText>
            <span style={{ marginLeft: '2px' }}>{props.searchInfo.qualifier}</span>
            <CopyIconComponent
              style={{
                cursor: 'pointer',
                color: '#000',
                position: 'absolute',
                top: -8,
                right: -30,
              }}
              textToCopy={`${props.searchInfo.block ? props.searchInfo.block + '-' : ''}${
                props.searchInfo.lot ? props.searchInfo.lot : ''
              }${props.searchInfo.qualifier ? '-' + props.searchInfo.qualifier : ''}`}
              afterCopyText="Copied SBL!"
            />
          </div>
        )}
        {props.searchInfo.continOrUpdateNumber > 0 && (
          <div style={{ position: 'relative', marginLeft: 'auto' }}>
            <BoldText>** CONTIN **</BoldText>
          </div>
        )}
      </div>
    </>
  );
};
